// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"225":"template","272":"order-form"}[chunkId] || chunkId) + "." + {"225":"8bafe959","272":"b8370007","351":"bcc13c40"}[chunkId] + ".js";
};